import { CompanyValidationSchema } from "@/components/pages/Settings/validation/companyValidationSchema";
import * as z from "zod";

const validationSchema = CompanyValidationSchema.pick({
  companyName: true,
  companyType: true,
  vatNumber: true,
  leiNumber: true,
  exportLicense: true,
  eoriNumber: true,
  phone: true,
  email: true,
  language: true,
  timeZone: true,
  defaultCurrency: true,
});

export const CompanySettingsValidationSchema = validationSchema;
export type CompanySettingsFormInput = z.infer<typeof CompanySettingsValidationSchema>;
